/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

export enum ledgerHeader {
  fundingDate = "Funding Date",
  merchantId = "Merchant ID",
  ledgerType = "Ledger Type",
  fundingStatus = "Funding Status",
  amount = "Amount",
  achType = "ACH Type",
  achDate = "ACH Date",
  fundingId = "Funding ID",
  achStatus = "ACH Status",
  processorMerchantId = "Processor Merchant ID",
  accountType = "Account Type",
  submerchantName = "Submerchant Name",
  reportGroup = "Report Group",
  suppressFeeSettlement = "Suppress Fee Settlement",
  responseTime = "Response Time",
  response = "Response"
}
